import { render, staticRenderFns } from "./ColumnActivities.vue?vue&type=template&id=37b4a7e0&scoped=true&"
import script from "./ColumnActivities.vue?vue&type=script&lang=js&"
export * from "./ColumnActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b4a7e0",
  null
  
)

export default component.exports